import { ReadProcessed } from 'components/hmilib/api';
import * as React from 'react';
import { Items } from '../../../../../hmilib/hmiclientbase';
import * as hmiclientsdata from '../../../../../hmilib/hmiclientsdata';
import { IDataHistory } from '../../../../../hmilib/hmiclientsdata';
import { Context } from '../../ContextVP';
import '../Tuning/index.css';
import Graph, { IRefs } from './components/Graph/Graph';
import PenAssigment from './components/Tab/Components/PenAssignment/PenAssignment';
import TrendsTab from './components/Tab/TrendsTab';
import TableTrends from './components/Table/TableTrends';
import './index.css';

// import { Context } from '../../Main';
// import { Context } from '../../Main';

export interface IPens {
    id: number;
    selected?: boolean;
    enable: boolean;
    name: string;
    curvalue?: string;
    desc?: string;
    eudesc?: string;
    min?: any;
    max?: any;
    color: string;
    typeLine: string | 'line' | 'linePoint' | 'point' | 'step' | 'areadiscrete' | 'radar';
    typeScale: string | 'auto' | 'system' | 'custom';
    yAxisIndex: number | undefined;
    markArea?: any[];
}

export interface IConfig {
    theme: string;
    tagConfig?: IPens[];
    idTrend: string;
    settings: ISettingsGraph;
}

interface ISettingsGraph {
    chart: IChart;
}

interface IChart {
    topmenu: boolean;
    bottommenu: boolean;
    tagonly: boolean;
    hasHistory: boolean;
    TypeTrend: number;
    hasLegend?: boolean;
    xAxis?: IAxisSetting | IAxisSetting[] | undefined;
    yAxis?: IAxisSetting | IAxisSetting[] | undefined;
    Title: string;
    radar?: any;
}

export interface IAxisSetting {
    type: string;
    min?: string;
    max?: string;
    delta?: string;
    name?: string;
}

interface Trends {
    bindings: any;
    TrendName: string;
    parentID: string;
    id?: string | undefined;
}

const TrendsIndex = (props: Trends) => {
    const { bindings } = props;

    const [idTrend, setidTrend] = React.useState<string | undefined>(undefined);

    const [xStart, setXStart] = React.useState<string | undefined>(undefined);
    const [xEnd, setXEnd] = React.useState<string | undefined>(undefined);

    const [archive, setArchive] = React.useState({});
    const [tempTestArchive, setTempTestArchive] = React.useState({});
    // const [archive, setArchive] = React.useState<{ [id: string]: [] }>({});
    // const [tempTestArchive, setTempTestArchive] = React.useState<{ [id: string]: [] }>({});

    const [archiveTrend, setArchiveTrend] = React.useState(false);
    const [HmiHistorySettings, setHmiHistorySettings] = React.useState<IPens[] | undefined>(undefined);
    const [config, setConfig] = React.useState<IConfig>({
        idTrend: '',
        theme: '',
        settings: {
            chart: {
                bottommenu: true,
                hasHistory: true,
                tagonly: true,
                Title: 'demo',
                topmenu: true,
                TypeTrend: 1,
                hasLegend: true,
                xAxis: {
                    type: 'time',
                    delta: '-2h'
                }
            }
        }
    });

    //обновление графика
    const UpdateGraphInterval = 1000;
    const MaxUpdateX = 1;

    // Рефы графика
    const refs: IRefs = {
        chartRef: React.useRef<any>(null),
        scrollRefX: React.useRef<HTMLDivElement>(null),
        scrollRefY: React.useRef<HTMLDivElement>(null)
    };

    let echarts_react: any = undefined;
    let coloritem = [
        '#00CCFF',
        '#967474',
        '#00cc00',
        '#ffcc00',
        '#ff00ff',
        '#ff0000',
        '#0000ff',
        '#8400ff',
        '#00ff84',
        '#ff8200',
        '#ff0084',
        '#84ffff',
        '#c6c3c6',
        '#84ff00',
        '#ffff84',
        '#ff82ff',
        '#ff8284',
        '#0082ff',
        '#8482ff',
        '#84ff84',
        '#ff8242',
        '#ff82c6',
        '#008284',
        '#848284',
        '#008200',
        '#848200',
        '#840084',
        '#840000',
        '#000084',
        '#420084',
        '#008242',
        '#844100'
    ];
    const [selectedPen, setSelectedPen] = React.useState<string>();

    const [refresh, setRefresh] = React.useState<boolean>(false);

    let dataTrendTree: any = React.useContext(Context);

    const myRef = React.createRef<HTMLDivElement>();

    let pens: any[] = [];
    let trendTime: { recordTime: any; samplingPeriod: any };

    const [samplingPeriod, setSamplingPeriod] = React.useState<any>();

    React.useEffect(() => {
        StartStopInterval(false);
        // if (dataTrendTree) pens = dataTrendTree.map(getPens)
        const fetchData = async () => {
            if (window.CentumTrendsTree) {
                pens = await getPens(window.CentumTrendsTree[0]);
                let pensNames: string[] = [];

                pens.forEach((pen: { name: string }) => {
                    pensNames.push(pen.name);
                });

                if (pens.length != 0) {
                    UpdateArchiveItems(pensNames);
                }
            }
        };
        fetchData();
        // pens = pens.flat()
    }, [bindings, refresh]);

    React.useEffect(() => {
        // let newid: string = props.id ? props.id : self.crypto.randomUUID();
        let newid = props.id;

        setidTrend(newid);

        if (newid) {
            let trend = window.Trends.IntTrend(newid);

            let containerId: any = myRef?.current?.parentNode;
            if (containerId) {
                containerId.getTrendInit = () => {
                    return trend;
                };
            }
        }
    }, [props.id]);

    function RefreshPen() {
        setRefresh((prevState) => !prevState);
    }

    const isEmpty = (obj: any) => {
        for (let key in obj) {
            return false;
        }
        return true;
    };

    async function getPens(obj: any): Promise<any[]> {
        let pens: any[] = [];
        for (let mKey in obj.blocks) {
            if (isEmpty(obj.blocks[mKey].blocks)) {
                const { Block, Group } = parseBindings(bindings);
                const BlockGroup = `${Block}/${Group}`;

                if (obj.path.includes(BlockGroup)) {
                    let block = obj.path.split('/').slice(0, -1).join('/');
                    let blockObj = Items[block];
                    // console.log(blockObj)
                    trendTime = {
                        recordTime: blockObj.parameters.RECORDTIME.CV,
                        samplingPeriod: blockObj.parameters.SAMPLINGPERIOD.CV * 1000
                    };

                    setSamplingPeriod(blockObj.parameters.SAMPLINGPERIOD.CV * 1000);

                    pens = await SaveGroupPens(obj);

                    return pens;
                }
            } else {
                const res = await getPens(obj.blocks[mKey]);
                if (res.length != 0) {
                    return res;
                } else {
                    getPens(obj.blocks[mKey]);
                }
            }
        }
        return pens;
    }

    function parseBindings(bindings: string) {
        const params = new URLSearchParams(bindings);
        return {
            Block: params.get('BLOCK'),
            Group: params.get('GROUP')
        };
    }

    async function SaveGroupPens(obj: any) {
        let pens: any[] = [];

        let Group = await fetchPenData(obj.path);

        for (let Key in Group.blocks) {
            let TagName: string = '';
            let PARAM: string = '';
            let DATA: string = '';

            if (Group.blocks[Key].bindinglist) {
                Group.blocks[Key].bindinglist.map((item: any, index: number) => {
                    if (item.name == 'TAG') {
                        TagName = item.Value;
                    }
                    if (item.name == 'PARAM') {
                        PARAM = item.Value;
                    }
                    if (item.name == 'DATA') {
                        DATA = item.Value;
                    }
                });
            }

            if (TagName != '' && TagName != undefined && TagName != null) {
                let lowlimit = Group.blocks[Key].parameters.LOWLIMIT.CV;
                let lowlimitPath = Group.blocks[Key].parameters.LOWLIMIT.path;
                let highlimit = Group.blocks[Key].parameters.HIGHLIMIT.CV;
                let highlimitPath = Group.blocks[Key].parameters.HIGHLIMIT.path;

                let enable =
                    Group.blocks[Key].parameters.HIGHLIMIT.sourceIn.Enable &&
                    Group.blocks[Key].parameters.LOWLIMIT.sourceIn.Enable;

                pens.push({
                    name: `${TagName}.${PARAM}`,
                    lowlimit: lowlimit,
                    lowlimitPath: lowlimitPath,
                    highlimit: highlimit,
                    highlimitPath: highlimitPath,
                    checked: enable,
                    TAG: TagName,
                    PARAM: PARAM,
                    DATA: DATA,
                    penPath: Group.blocks[Key].path
                });
            }
        }

        return pens;
    }

    const updateDataParam = async (
        data: IDataHistory[],
        group: number | undefined = undefined,
        Select: string | undefined = undefined
    ) => {
        if (Select == '' || Select == null || '$SELECT' == Select) {
            Select = '';
        }
        Select = Select.toUpperCase();

        window.parent.SubItems(data.map((ele) => ele.ID));

        let newdataobj: any = {};

        if (data) {
            let temparchive = {};
            let tempHmiHistorySettings: IPens[] = new Array(coloritem.length);
            let tempColor: any[] = [];
            if (HmiHistorySettings !== undefined) {
                HmiHistorySettings.forEach((item) => {
                    tempColor.push(item.color);
                });
            }

            let HistorySettings: any = undefined;
            if (group != undefined && group != 0) {
                HistorySettings = hmiclientsdata.GetHistorySettings()[group];
            }

            let activeitem = false;

            let endtimeiso = new Date().toISOString();

            let idlist = 0;

            for (let id2 in data) {
                idlist++;
                let name = data[id2].ID;
                let lastTime = data[id2].T[data[id2].T.length - 1];

                if (!archiveTrend) {
                    if (lastTime < Number(endtimeiso)) {
                        let parnew = window.parent.GetParam(name);
                        if (parnew.V != name) {
                            let val = Number(Number(parnew.V).toFixed(3));
                            data[id2].T.push(window.ConvertDateISOtoNs(window.SystemDate()));
                            data[id2].Q?.push(Number(parnew.Q));
                            data[id2].V.push(val);
                        }
                    }
                }

                let minMax_markArea = await getMinMax_markArea(data[id2]);

                let newdata = [];

                for (let ida = data[id2].V.length; ida--; ) {
                    let val = data[id2].V[ida];
                    if ((config.settings.chart?.xAxis as IAxisSetting)?.type != 'time') {
                        newdata.unshift([data[id2].T[ida], val]);
                    } else {
                        newdata.unshift([GetDate(data[id2].T[ida]), val]);
                    }
                }

                let HistSettings = tempHmiHistorySettings.filter((f) => f.name == name)[0];

                if (HistSettings?.selected) {
                    activeitem = true;
                }

                let desc = '';
                let eudesc = '';
                HistSettings = CreateItem(idlist, name, desc, eudesc, undefined, 'auto');
                tempHmiHistorySettings[idlist - 1] = HistSettings;
                HistSettings.max = minMax_markArea.max;
                HistSettings.min = minMax_markArea.min;
                HistSettings.markArea = minMax_markArea.markArea;

                if (HistorySettings != null) {
                    if (HistorySettings[idlist - 1].min != null) {
                        HistSettings.min = HistorySettings[idlist - 1].min;
                    }
                    if (HistorySettings[idlist - 1].max != null) {
                        HistSettings.max = HistorySettings[idlist - 1].max;
                    }
                    let enable = HistorySettings[idlist - 1].enable;
                    let step = HistorySettings[idlist - 1].step;
                    HistSettings.enable = enable;
                }

                newdataobj[name] = newdata;
            }

            for (let i = 0; i < tempHmiHistorySettings.length; i++) {
                if (!tempHmiHistorySettings[i]) {
                    let active = false;
                    tempHmiHistorySettings[i] = {
                        id: i + 1,
                        color: coloritem[i],
                        curvalue: '',
                        yAxisIndex: undefined,
                        desc: '',
                        eudesc: '',
                        min: 0,
                        max: 100,
                        enable: false,
                        name: '',
                        selected: active,
                        typeLine: 'line',
                        typeScale: 'auto'
                    };
                }

                if (
                    (tempHmiHistorySettings[i].name.indexOf(Select) == 0 && Select != '') ||
                    (!activeitem && Select == '') ||
                    (!activeitem && Select == undefined)
                ) {
                    tempHmiHistorySettings[i].selected = true;
                    activeitem = true;
                }
            }

            let temparchivenew = { ...temparchive, ...newdataobj };

            setArchive(temparchivenew);
            setHmiHistorySettings(tempHmiHistorySettings);
        }
    };

    let CreateItem = function (
        id: number,
        param: string,
        desc: string,
        eudesc: string,
        typeLine: string | undefined,
        typeScale: string,
        colorItem?: string
    ): IPens {
        let item = param.toUpperCase().substr(0, param.lastIndexOf('.'));

        if (item.indexOf('.VALUE') != -1) {
            item = param.toUpperCase().substr(0, item.lastIndexOf('.'));
        }

        let curvalue = Number(window.parent.GetParam(param).V).toFixed(3);

        let tempDesc = '';
        let tempEudesc = '';

        let minmax = 1;
        if (Number(curvalue) > 1) {
            minmax = Number(curvalue) * 2;
        }

        let min = (Number(window.parent.GetParam(param).V) - minmax).toFixed(3);
        let max = (Number(window.parent.GetParam(param).V) + minmax).toFixed(3);
        let index = id;

        let color = coloritem[index - 1];
        if (colorItem !== undefined) {
            color = colorItem;
        }

        let enable = true;
        let yAxisIndex = undefined;

        if (config.tagConfig) {
            if (typeLine == null) {
                typeLine = config.tagConfig[id - 1]?.typeLine || 'line';
            }

            yAxisIndex =
                config.tagConfig[id - 1]?.yAxisIndex != null ? config.tagConfig[id - 1]?.yAxisIndex : yAxisIndex;

            enable = config.tagConfig[id - 1]?.enable;
            if (config.tagConfig[id - 1]?.color !== undefined) {
                color = config.tagConfig[id - 1]?.color;
            }
            tempDesc = config.tagConfig[id - 1]?.desc || '';
            tempEudesc = config.tagConfig[id - 1].eudesc || '';
        }

        if (tempDesc == '' || tempDesc == null) {
            desc = window.parent.GetParam(item + '.description').V;
            if (desc == '.description' || desc == null || desc == 'null') desc = '';
        } else {
            desc = window.parent.GetParam(tempDesc).V;
        }

        if (tempEudesc !== null) {
            eudesc = window.parent.GetParam(tempEudesc).V;
        }

        if (typeLine == null) {
            typeLine = 'line';
        }
        let tempMarkArea: any = {
            itemStyle: {
                color: 'rgba(255, 173, 177, 0.3)'
            },
            data: []
        };

        let itemalarm: IPens = {
            id: id,
            color: color,
            curvalue: curvalue,
            desc: desc,
            eudesc: eudesc,
            min: min,
            max: max,
            enable: enable,
            name: param,
            selected: false,
            typeLine: typeLine,
            typeScale: typeScale,
            yAxisIndex: yAxisIndex,
            markArea: tempMarkArea
        };
        return itemalarm;
    };

    function UpdateArchiveItems(param: string[]) {
        setArchive({});
        let arraySelectPen: string[] = [];

        ReadHistoryData(param).then(async (data: any) => {
            if (data) {
                if (data.length == 0) {
                    pens.map((item, index) => {
                        let pen = {
                            ID: `${item.DATA}/${item.name}`,
                            Q: [],
                            V: [],
                            T: []
                        };

                        data.push(pen);
                    });
                }

                arraySelectPen = data.map((item: { ID: any }) => item.ID);

                await Promise.all(
                    data.map(async (item: { ID: any }, index: number) => {
                        let penPath = item.ID.replace('.PV', '');
                        let PID = await fetchPenData(penPath);
                        if (PID != null) {
                            if (PID.parameters.HH != undefined && PID.parameters.LL != undefined) {
                                pens[index]['HH'] = PID.parameters.HH.CV;
                                pens[index]['LL'] = PID.parameters.LL.CV;
                            } else {
                                pens[index]['HH'] = 0;
                                pens[index]['LL'] = 0;
                            }
                        }
                    })
                );

                setSelectedPen(arraySelectPen[0]);

                updateDataParam(data);

                TestData(arraySelectPen);

                //Запуск интервала, если скролл в крайнем правом положении
                const containerRectX = refs.scrollRefX.current?.parentElement;
                const containerWidth = containerRectX?.offsetWidth || 0;
                if (refs.scrollRefX.current?.offsetWidth) {
                    let leftPosition = containerWidth - refs.scrollRefX.current?.offsetWidth;
                    if (refs.scrollRefX.current?.offsetLeft === leftPosition + 2) {
                        StartStopInterval(true);
                    }
                }
            }
        });
    }

    const ReadHistoryData = async function (Items: string[]) {
        let endtimeiso = new Date().toISOString();

        const CurrentTime = new Date();

        let hours = trendTime.recordTime / 3600;

        CurrentTime.setHours(CurrentTime.getHours() - hours);
        let starttimeiso = CurrentTime.toISOString();

        let funcName: string[] = [];
        Items.forEach((element) => funcName.push('INTERPOLATIVE'));

        let maxPoint = 1500;
        let countPoint = maxPoint;

        let deltaNs = (new Date(endtimeiso).getTime() - new Date(starttimeiso).getTime()) * 1000000;

        let intervalNs = Math.floor(deltaNs / countPoint);

        return ReadProcessed(Items, funcName, starttimeiso, endtimeiso, intervalNs);
    };

    const UpdateArchive = (newseries: any[]) => {
        if (HmiHistorySettings) {
            setArchive((prevArchive) => {
                let cloneHmiHistory = HmiHistorySettings.slice();
                let temparchive: any = JSON.parse(JSON.stringify(prevArchive));

                for (let paramind = HmiHistorySettings.length; paramind--; ) {
                    if (newseries[paramind]) {
                        for (let i in newseries[paramind]) {
                            let val = Number(newseries[paramind][i][1]);
                            let t = newseries[paramind][i][0];

                            let len = temparchive[cloneHmiHistory[paramind].name]?.length || 0;
                            if (len > 2) {
                                if (xStart) {
                                    if (temparchive[cloneHmiHistory[paramind].name][1][0] < xStart) {
                                        temparchive[cloneHmiHistory[paramind].name].shift();
                                        len--;
                                    }
                                }

                                let lastval = temparchive[cloneHmiHistory[paramind].name][len - 1];

                                if (temparchive[cloneHmiHistory[paramind].name][len - 2][1] == lastval[1]) {
                                    temparchive[cloneHmiHistory[paramind].name][len - 2][0] = lastval[0];
                                    temparchive[cloneHmiHistory[paramind].name].pop();
                                    len--;
                                }
                            }

                            if (len > 0) {
                                if (t > temparchive[cloneHmiHistory[paramind].name][len - 1][0]) {
                                    temparchive[cloneHmiHistory[paramind].name].push([t.toISOString(), val]);
                                    if (cloneHmiHistory[paramind].typeScale === 'auto') {
                                        if (cloneHmiHistory[paramind].max < val) {
                                            let scaleminmax = Math.abs(
                                                Number(val) - Number(cloneHmiHistory[paramind].min)
                                            );
                                            cloneHmiHistory[paramind].max = Number(
                                                Number(val) + scaleminmax * 0.1
                                            ).toFixed(3);
                                        } else if (cloneHmiHistory[paramind].min > val) {
                                            let scaleminmax = Math.abs(
                                                Number(cloneHmiHistory[paramind].max) - Number(val)
                                            );
                                            cloneHmiHistory[paramind].min = Number(
                                                Number(val) - scaleminmax * 0.1
                                            ).toFixed(3);
                                        }
                                    }
                                } else {
                                    temparchive[cloneHmiHistory[paramind].name].push([
                                        window.SystemDate().toISOString(),
                                        val
                                    ]);
                                }
                            }

                            cloneHmiHistory[paramind].curvalue = val.toString();
                        }
                    }
                }

                setHmiHistorySettings(cloneHmiHistory);
                return temparchive;
            });
        }
    };

    const [playStopDisplay, setPlayStopDisplay] = React.useState(false);
    let id = React.useRef<NodeJS.Timeout | undefined>();

    React.useEffect(() => {
        const clearExistingInterval = () => {
            if (id.current) {
                clearInterval(id.current);
                id.current = undefined;
            }
        };

        clearExistingInterval();

        id.current = setInterval(Update, samplingPeriod);

        return () => {
            clearExistingInterval();
        };
    }, [playStopDisplay]);

    function StartStopInterval(check: boolean) {
        setPlayStopDisplay(check);
    }

    let iUpdateX = 1;

    const [newSeriesPoints, setNewSeriesPoints] = React.useState<any[]>([]);

    async function Update() {
        try {
            if (HmiHistorySettings && !archiveTrend) {
                let newseries: any = {};
                let t;
                for (let paramind = HmiHistorySettings.length; paramind--; ) {
                    if (HmiHistorySettings[paramind].name != '') {
                        let parnew = window.parent.GetParam(HmiHistorySettings[paramind].name);
                        let val = parnew.V;
                        t = window.SystemDate();
                        // t = new Date(t).getTime();
                        newseries[paramind] = [[t, val]];
                    }
                }

                UpdateArchive(newseries);
                // console.log(archive)

                // setNewSeriesPoints(prevState => [...prevState, ...newseries]);

                if (iUpdateX == 0) {
                    let newconfig = { ...config };

                    if (newconfig.settings?.chart?.xAxis as IAxisSetting) {
                        (newconfig.settings.chart.xAxis as IAxisSetting).max = window.ConvertDateISOtoNs(
                            new Date(window.SystemDate().setMilliseconds(MaxUpdateX * samplingPeriod))
                        );
                    }
                }

                if (iUpdateX >= MaxUpdateX) {
                    // setiUpdateX(0);
                    iUpdateX = 0;
                } else {
                    // setiUpdateX(iUpdateX + 1);
                    iUpdateX++;
                }
            }
            // setTimeout(Update, UpdateGraphInterval);
        } catch (ex) {
            console.dir(ex);
        }
    }

    const SetConfigNew = function (confignew: IConfig) {
        if (confignew.settings.chart.xAxis) {
            if (
                (confignew.settings.chart.xAxis as IAxisSetting)?.delta?.includes('h') &&
                (confignew.settings.chart.xAxis as IAxisSetting)?.type == 'time'
            ) {
                if ((confignew.settings.chart.xAxis as IAxisSetting)?.max == null) {
                    let xDelta =
                        Number((confignew.settings.chart.xAxis as IAxisSetting)?.delta?.replaceAll('h', '')) * 3600000;
                    let min = window.ConvertDateISOtoNs(new Date(window.SystemDate().setMilliseconds(xDelta)));
                    let max = window.ConvertDateISOtoNs(new Date(window.SystemDate().setMilliseconds(5000)));

                    (confignew.settings.chart.xAxis as IAxisSetting).min = min;
                    (confignew.settings.chart.xAxis as IAxisSetting).max = max;
                }
            }
        }

        if (confignew.tagConfig) {
            for (let i = 0; i < confignew.tagConfig?.length; i++) {
                confignew.tagConfig[i].enable =
                    confignew.tagConfig[i].enable == null || confignew.tagConfig[i].enable == true ? true : false;
            }
        }

        let max = null;
        let min = null;
        if (
            (confignew.settings.chart.xAxis as IAxisSetting)?.min != '' &&
            (confignew.settings.chart.xAxis as IAxisSetting)?.min != null
        ) {
            min = (confignew.settings.chart.xAxis as IAxisSetting).min;
            if ((confignew.settings.chart.xAxis as IAxisSetting).type == 'time') {
                min = GetDate(min);
                (confignew.settings.chart.xAxis as IAxisSetting).min = min;
            }

            setXStart(min);
        }

        if (
            confignew.settings.chart.xAxis &&
            (confignew.settings.chart.xAxis as IAxisSetting)?.max != '' &&
            (confignew.settings.chart.xAxis as IAxisSetting)?.max != null
        ) {
            max = (confignew.settings.chart.xAxis as IAxisSetting).max;
            if ((confignew.settings.chart.xAxis as IAxisSetting).type == 'time') {
                max = GetDate(max);
                (confignew.settings.chart.xAxis as IAxisSetting).max = max;
            }

            setXEnd(max);
        } else if (min == null && max == null) {
            console.log('not set xAxis');
        }

        setConfig(confignew);
    };

    async function getMinMax_markArea(data: IDataHistory) {
        let newMin: number | null = null;
        let newMax: number | null = null;

        let tempMarkArea: any = {
            itemStyle: {
                color: 'rgba(255, 173, 177, 0.3)'
            },
            data: []
        };
        let startMarkArea: boolean = false;

        for (let i = data.V.length; i--; ) {
            let val = data.V[i];

            if (data.Q) {
                if (data.Q[i] !== 0) {
                    if (!startMarkArea) {
                        if (data.V.length !== i) {
                            tempMarkArea.data.unshift([{}, { xAxis: GetDate(data.T[i + 1]) }]);
                            startMarkArea = true;
                        }
                    }
                } else {
                    if (startMarkArea) {
                        tempMarkArea.data[0][0].xAxis = GetDate(data.T[i + 1]);
                        startMarkArea = false;
                    }
                }
            }

            if (!Number.isNaN(Number(val))) {
                if (newMin === null || Number.isNaN(newMin)) {
                    newMin = val;
                }
                if (newMax === null || Number.isNaN(newMax)) {
                    newMax = val;
                }
            }
            if (newMin != null && newMax != null) {
                if (val > newMax) {
                    newMax = val;
                } else if (val < newMin) {
                    newMin = val;
                }
            }
        }

        let scaleminmax = Math.abs(Number(newMax?.toFixed(3)) - Number(newMin?.toFixed(3)));
        scaleminmax = Number(scaleminmax.toFixed(3));
        if (scaleminmax === 0) {
            scaleminmax = 1;
        } else if (scaleminmax < 0.2) {
            scaleminmax = 0.2;
        }

        let max = '0';
        if (newMax != null) {
            max = Number(newMax + scaleminmax * 0.05).toFixed(3);
        }
        let min = '0';
        if (newMin != null) {
            min = Number(newMin - scaleminmax * 0.05).toFixed(3);
        }

        let penName: any = data.ID.split('/');
        penName = penName[penName.length - 1];

        const foundItem = pens.find((item: { name: any }) => item.name === penName);

        if (foundItem) {
            if (foundItem.highlimit != foundItem.lowlimit) {
                max = foundItem.highlimit;
                min = foundItem.lowlimit;
            } else {
                max = foundItem.HH;
                min = foundItem.LL;
            }
        }

        return { max: max, min: min, markArea: tempMarkArea };
    }

    async function fetchPenData(penPath: string) {
        try {
            const response = await fetch(window.hostdata + `/Base/GetObject?path=${penPath}`);
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Ошибка при получении данных:', error);
            return null;
        }
    }

    const GetDate = (datelong: any) => {
        if (typeof datelong == 'number') {
            return window.ConvertDateNsToISO(datelong);
        } else {
            return new Date(datelong);
        }
    };

    // Tabs buttons
    const handleChartRef = (ref: any) => {
        // ChartRef.current = ref;
    };

    const [showPenAssignment, setShowPenAssignment] = React.useState(false);
    const handlePenAssignment = () => {
        setShowPenAssignment(true);
        StartStopInterval(false);
    };

    const closePenAssignment = (blockInterval: boolean = false) => {
        setShowPenAssignment(false);
        if (!blockInterval) {
            StartStopInterval(true);
        }
    };

    const [data, setData] = React.useState<any[]>();
    const [groupPensInfo, setgroupPensInfo] = React.useState<any[]>();
    //таблица для теста
    function TestData(dataNames: any) {
        let updatedArray = dataNames.map((item: string) => item.replace('.PV', ''));
        // return arrTest;
        setData(updatedArray);
        setgroupPensInfo(pens);
    }

    const enablePen = (penName: string, id: number, state: boolean) => {
        if (HmiHistorySettings) {
            let itemsAlarm = HmiHistorySettings.slice();
            itemsAlarm[id].enable = state;
            setHmiHistorySettings(itemsAlarm);
        }
    };

    const selectPen = (penName: string) => {
        setSelectedPen(penName);
    };

    if (HmiHistorySettings) {
        if (props.TrendName == 'centumtrends') {
            return (
                <React.Fragment>
                    <div ref={myRef} className={`CentumVPTrends-${props.TrendName}`}>
                        <div className="сentum-trends">
                            <div className="trends-tabs">
                                <TrendsTab
                                    refs={refs}
                                    pens={HmiHistorySettings}
                                    callbackPenAssignment={handlePenAssignment}
                                />
                            </div>
                            <div className="trends-graph">
                                <div className="trends-main-graph">
                                    <div className="scale-background"></div>
                                    <Graph
                                        refs={refs}
                                        data={archive}
                                        selectedPen={selectedPen}
                                        pens={HmiHistorySettings}
                                        groupPensInfo={groupPensInfo}
                                        parentID={props.parentID}
                                        samplingPeriod={samplingPeriod}
                                        echarts_react={echarts_react}
                                        config={config}
                                        playStopDisplay={playStopDisplay}
                                        newSeriesPoints={newSeriesPoints}
                                        onChartRef={handleChartRef}
                                        SetInterval={StartStopInterval}
                                    />
                                </div>
                            </div>
                            {showPenAssignment && (
                                <React.Fragment>
                                    <PenAssigment
                                        Top={0}
                                        Left={0}
                                        title={'Pen Assignment'}
                                        parentID={props.parentID}
                                        group={groupPensInfo}
                                        fullGroup={data}
                                        RefreshPen={RefreshPen}
                                        OnClose={closePenAssignment}
                                    />
                                </React.Fragment>
                            )}
                            <div className="trends-table">
                                <TableTrends
                                    pensData={groupPensInfo}
                                    data={archive}
                                    parentID={props.parentID}
                                    group={data}
                                    refs={refs}
                                    newSeriesPoints={newSeriesPoints}
                                    playStopDisplay={playStopDisplay}
                                    callbackSelectPen={selectPen}
                                    callbackEnablePen={enablePen}
                                />
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            );
        } else {
            return <React.Fragment></React.Fragment>;
        }
    } else {
        return <React.Fragment></React.Fragment>;
    }
};

export default TrendsIndex;
